<template>
  <div class="min-h-screen">
    <!-- Page Title & Overview -->


    <!-- Story -->
    <div class="bg-white">
      <div class="relative max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div class="hidden lg:block bg-gray-50 absolute top-0 bottom-0 left-3/4 w-screen" />
        <div class="mx-auto text-base max-w-prose lg:grid lg:grid-cols-2 lg:gap-8 lg:max-w-none">
          <div>
            <h3 class="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">{{ Story.Title }}</h3>
          </div>
        </div>
        <div class="mt-8 lg:grid lg:grid-cols-2 lg:gap-8">
          <div class="relative lg:row-start-1 lg:col-start-2">
            <svg class="hidden lg:block absolute top-0 right-0 -mt-20 -mr-20" width="404" height="384" fill="none" viewBox="0 0 404 384" aria-hidden="true">
              <defs>
                <pattern id="de316486-4a29-4312-bdfc-fbce2132a2c1" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                  <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
                </pattern>
              </defs>
              <rect width="404" height="384" fill="url(#de316486-4a29-4312-bdfc-fbce2132a2c1)" />
            </svg>
            <div class="relative text-base mx-auto max-w-prose lg:max-w-none">
              <figure class="w-full flex flex-col items-center mb-8">
                <div class="w-full max-w-[512px]">
                  <img class="rounded-lg shadow-lg object-cover object-center w-full h-64 sm:h-72 md:h-80 lg:h-96" :src="whitehouseImage" alt="Jonathan, Mike, and JO in 2019" />
                </div>
                <figcaption class="mt-2 text-sm text-gray-500 text-center">
                  Jonathan, Mike, and JO in 2019
                </figcaption>
              </figure>
              <figure class="w-full flex flex-col items-center">
                <div class="w-full max-w-[512px]">
                  <img class="rounded-lg shadow-lg object-cover object-center w-full h-64 sm:h-72 md:h-80 lg:h-96" :src="partyImage" alt="Awetomaton 2023 Holiday Party @ Mud Lick Tap House" />
                </div>
                <figcaption class="mt-2 text-sm text-gray-500 text-center">
                  Awetomaton 2023 Holiday Party @ Mud Lick Tap House
                </figcaption>
              </figure>
            </div>
          </div>
          <div class="mt-8 lg:mt-0">
            <div class="text-base max-w-prose mx-auto lg:max-w-none">
              <p class="text-xl text-gray-500 leading-8">
                The vision for Awetomaton started a decade ago. Like many ideas it was born out of frustration with the compromises and challenges experienced as a defense contractor.
              </p>
              
              <div class="pl-4 border-l-4 border-awtmtn-dark-blue mt-6">
                <p class="text-lg text-gray-600 italic mb-2">What if there were less rules and more individual autonomy?</p>
                <p class="text-lg text-gray-600 italic mb-2">What if everyone in the company was passionate and capable?</p>
                <p class="text-lg text-gray-600 italic mb-2">What if every project was meaningful and challenging?</p>
                <p class="text-lg text-gray-600 italic mb-2">What if the team had all the tools & resources needed to succeed?</p>
                <p class="text-lg text-gray-600 italic mb-2">What if our priority was mission execution over profit maximization?</p>
              </div>
              
              <p class="text-lg text-gray-500 font-medium mt-6">
                Driven by these questions and a deep desire to inspire a culture for speed and pride while supporting the defense industry, Awetomaton was founded in 2020.
              </p>
              
              <p class="text-lg text-gray-500 mt-6">
                With no external investors and fully bootstrapped, we've grown largely by word-of-mouth to over 30.
              </p>
              
              <p class="text-lg text-awtmtn-dark-blue font-semibold mt-6">
                Our commitment remains unchanged. Work with smart people to solve meaningful problems in an environment that enables you to do your best work.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { LeadIn, Story, Staff } from '../data/about.json'
import whitehouseImage from '@/assets/team/whitehouse1.jpg'
import partyImage from '@/assets/team/2023-party.jpg'

export default defineComponent({
  name: 'About',
  setup() {
    return {
      LeadIn,
      Story,
      Staff,
      whitehouseImage,
      partyImage
    }
  }
})
</script>